import { useEffect } from "react";
import { Navbar } from "./navbar";
import aboutCover from "../assets/images/aboutCover.jpg"
import warranty from "../assets/images/warranty.jpg"
import operation from "../assets/images/operation.jpg"
import experienceIco from "../assets/images/experienceIco.svg"
import expertIco from "../assets/images/expertIco.svg"
import familyIco from "../assets/images/familyIco.svg"
import materialIco from "../assets/images/materialIco.svg"
import industryIco from "../assets/images/industryIco.svg"
import quickIco from "../assets/images/quickIco.svg"
import { Link } from "react-router-dom";

export function About() {
    useEffect(()=>{
        window.scrollTo(0, 0);
    },[])

    return(
        <div className="aboutUsPage">
            <div className="container">
                <Navbar />
            </div>
            <div className="sec1">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <h1 className="heading56 mb-4">Client-Focused Professional <span> Roofing Repair</span> and <span>Installation Services</span></h1>
                        </div>
                        <div className="col-md-6">
                            <p className="text22">At Corolla Roofing, we consider each roofing project an opportunity to grow our company through premium customer service and high-quality outcomes. That means we approach every new roofing service and repair with the same dedication we would with our own family members.</p>
                        </div>
                    </div>
                </div>
            </div>

            <section className="cover">
                <img className="w-100" src={aboutCover} alt="about" />
            </section>

            <section className="differentSec">
                <div className="container">
                    <h1 className="heading56 mb-3 text-center">What Makes Us <span> Different</span></h1>
                    <p className="text22 text-center">Corolla Roofing blends the modern technology and tools of today with old-fashioned superior craftwork, New Englanders know and trust. Our roofing experts rely on years of experience handling durable, aesthetically pleasing projects, and problem-solving for our area's different seasons and weather.</p>
                    <div className="row mt-5">
                        <div className="col-lg-4 col-sm-6 mb-4"> 
                            <DifferentCard image={experienceIco} title="Experience" desc="Our leadership team has more than 30 years of experience in the roofing industry handling all kinds of client needs and challenges." />
                        </div>
                        <div className="col-lg-4 col-sm-6 mb-4">
                            <DifferentCard image={expertIco} title="Expertise" desc="We leverage the skills of seasoned roofing experts through bespoke communication so that every project is treated with the utmost care and due diligence." />
                        </div>
                        <div className="col-lg-4 col-sm-6 mb-4">
                            <DifferentCard image={familyIco} title="family Owned" desc="We are a proud family-owned New England business respecting the old traditional designs of local homes and modern solutions to ensure a long-lasting roof solution." />
                        </div>
                        <div className="col-lg-4 col-sm-6 mb-4">
                            <DifferentCard image={materialIco} title="quality Materials" desc="All of our roofing technicians stay up to date on how to repair and install the latest materials to accommodate any client request for residential, commercial, and industrial roofs." />
                        </div>
                        <div className="col-lg-4 col-sm-6 mb-4">
                            <DifferentCard image={industryIco} title="Industry Qualified" desc="Corolla Roofing is fully licensed, insured, and approved by all major roofing manufacturers, allowing us to maintain warranties and specifications." />
                        </div>
                        <div className="col-lg-4 col-sm-6 mb-4">
                            <DifferentCard image={quickIco} title="Quick Service" desc="Our crews are on-call 7 days a week to respond to roofing emergencies. We want you, your family, and your business protected, regardless of the season." />
                        </div>
                    </div>
                </div>
            </section>

            <section className="ourOperationSec"> 
                <div className="container">
                    <div className="row ai-center">
                        <div className="col-lg-5">
                            <div className="text-center">
                                <img src={operation} alt="homeImg1" className="img-fluid" />
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="content">
                                <h1 className="heading56 mb-4">Our <span>Operations</span></h1>
                                <p className="text22">Corolla Roofing operates in and around New England. You can see more details from our projects page about the many roofing services and repair jobs we have completed to better understand our breadth of experience.</p>
                                <Link to="/contact" className="blueOutlineBtn mt-4">Contact Us</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="manufacturerSec"> 
                <div className="container">
                    <h1 className="heading56 mb-4">Manufacturer Warranties</h1>
                    <div className="row">
                        <div className="col-lg-7 ">
                            <p className="text22 mb-0">All major roofing manufacturers approve Corolla Roofing, including providing such warranties for Carlisle, Firestone, Versico, Sarnafil, GAF, Garland, Tremco, Gen-Flex, John Mansville, Hickman, and all Shingle Roofing Systems. This allows Corolla Roofing to act as a liaison between the roofing manufacturer and the client to ensure the client gets the quality they deserve from their roofing system.</p>
                            <Link to="/contact" className="blueOutlineBtn mt-4">Contact Us</Link>
                        </div>
                        <div className="col-lg-5 text-center">
                            <div className="imgDiv">
                                <img src={warranty} alt="homeImg1" className="img-fluid" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>


        </div>
    )
}

const DifferentCard = ({image, title,desc}) =>{
 return(
    <div className="difftrerntCard">
        <div className="logoDiv">
            <img src={image} alt="experience" />
        </div>
        <div className="title mt-1 mb-3">{title}</div>
        <p>{desc}</p>
    </div>
 )
}